import { useEffect, useState } from "react";
import { Crown } from "lucide-react";
import { api } from "@/lib/api";

const PODIUM = ["border-pink-400 bg-pink-500/10", "border-cyan-400 bg-cyan-400/10", "border-violet-400 bg-violet-500/10"];

export default function Classifica() {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/leaderboard").then((r) => setRows(r.data)).catch(() => setRows([])); }, []);
  return (
    <div className="space-y-8">
      <h1 className="text-4xl font-bold sm:text-5xl">Classifica</h1>
      <div className="luma-card text-sm text-muted-foreground" data-testid="points-rules">
        <b className="text-foreground">Come si ottengono i punti:</b> 100 punti per ogni scelta confermata dal manga; +30 se quella teoria era stata scelta da meno del 20% dei voti validi alla chiusura; 0 negli altri casi. Contano solo gli utenti registrati, con il loro nickname.
      </div>
      {rows && rows.length === 0 && <p data-testid="leaderboard-empty" className="text-muted-foreground">Per i punti servirà un po' di pazienza. Prima o poi Oda ci darà qualche risposta. Forse.</p>}
      <div className="grid gap-4 sm:grid-cols-3">
        {(rows || []).slice(0, 3).map((r, i) => (
          <div key={r.user_id} className={`rounded-2xl border-2 p-5 ${PODIUM[i]}`} data-testid={`podium-${i + 1}`}>
            <Crown size={20} />
            <p className="mt-2 font-display text-xl font-bold">{r.posizione}° {r.nome}</p>
            <p className="text-sm text-muted-foreground">{r.punti} punti · {r.corretti}/{r.pronostici} corretti</p>
          </div>
        ))}
      </div>
      <div className="overflow-x-auto rounded-2xl border border-border">
        <table className="w-full text-sm" data-testid="leaderboard-table">
          <thead className="bg-muted/50 text-left text-xs uppercase text-muted-foreground">
            <tr><th className="p-3">#</th><th className="p-3">Utente</th><th className="p-3">Punti</th><th className="p-3">Corretti</th></tr>
          </thead>
          <tbody>
            {(rows || []).map((r) => (
              <tr key={r.user_id} className="border-t border-border" data-testid={`leaderboard-row-${r.user_id}`}>
                <td className="p-3 font-bold">{r.posizione}</td><td className="p-3">{r.nome}</td>
                <td className="p-3 font-bold text-primary">{r.punti}</td><td className="p-3">{r.corretti}/{r.pronostici}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
